module.exports = __webpack_public_path__ + "img/Pt-T200.dcb002d1.gif";